/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TenantCurrencyConfigResponse } from '../models/TenantCurrencyConfigResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CurrencyService {
    /**
     * @returns TenantCurrencyConfigResponse Ok
     * @throws ApiError
     */
    public static getTenantCurrencyConfig(): CancelablePromise<TenantCurrencyConfigResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/currency/config',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden.`,
            },
        });
    }
}
